module.exports = __webpack_public_path__ + "img/googlePay.30bd0c10.svg";